import { RawRuleOf } from '@casl/ability';

import { PLATFORM_SUBJECTS } from '../consts/subject-scope-by-subject.const';
import { AppSubjectEnum } from '../enums/app-subject.enum';
import { UserActionEnum } from '../enums/user-action.enum';
import { AppAbility } from '../types/app-ability';

/**
 * Parses `action:subject` permission strings from a JWT payload into CASL rules.
 * @param jwtPayload - JWT payload containing a `permissions` string array.
 * @returns Parsed permission rules; invalid entries are omitted.
 * @example
 * parseJwtPermissions({
 *   permissions: ['view:vehicle', 'invalid', 'create:customer'],
 * });
 */
export function parseJwtPermissions(
  jwtPayload: { permissions?: string[] } | null | undefined,
): RawRuleOf<AppAbility>[] {
  return (
    jwtPayload?.permissions
      ?.map((permission) => {
        const [action, subject] = permission.split(':');

        if (
          !Object.values(UserActionEnum).includes(action as UserActionEnum) ||
          !Object.values(AppSubjectEnum).includes(subject as AppSubjectEnum)
        ) {
          return null;
        }

        if (subject === AppSubjectEnum.PLATFORM_ALL) {
          return {
            action: action as UserActionEnum,
            subject: PLATFORM_SUBJECTS,
          };
        }

        return {
          action: action as UserActionEnum,
          subject: subject as AppSubjectEnum,
        };
      })
      .filter((permission) => permission !== null) ?? []
  );
}
